// extracted by mini-css-extract-plugin
module.exports = {"leftSidebar":"style_leftSidebar__3RdeO"};